import { FavouriteDefinition, Value } from 'app/types-shared';

export const updateExposure = (definition: FavouriteDefinition,
  exposureApplication: Value, exposureFactor: number, exposurePercent: number
): FavouriteDefinition => {

  return {
    ...definition,
    exposureApplication: exposureApplication?.v ? exposureApplication: undefined,
    exposureFactor,
    exposurePercent
  };
};
